import styled from '@emotion/styled';
import { Modal } from '../Modal';
import { BreakpointsEnum } from '../../helpers/breakpoints';
import { Button } from '../Button/Button';
import { CrossIcon } from '../Icons/CrossIcon';
import { InputComponent } from '../RequestFormPersonalInfo/ControlComponents';
import { WarningIcon } from '../Icons/newIcons/WarningIcon';

export const ScrollWrapper = styled.div`
    display: flex;
    flex-direction: column;
    overflow: auto;
    max-heigth: 100%;
`;

export const CloseButton = styled.button`
    background: none;
    border: 0;
`;

export const StyledCrossIcon = styled(CrossIcon)`
    width: 16px;
    height: 16px;
    fill: ${({ theme }) => theme.colors.gunmetal[50]};
`;

export const ModalTitle = styled.h3`
    font-size: 20px;
    margin: 0;
`;

export const ModalHeader = styled.div`
    font-size: 20px;
    font-weight: 600;
    line-height: 32px;
    text-align: left;

    color: ${({ theme }) => theme.text.color.primary};
    padding: 24px;
    border-bottom: 2px solid ${({ theme }) => theme.colors.whiteSmoke[100]};
    display: flex;
    justify-content: space-between;
`;
export const ModalContent = styled.div`
    padding: 24px;

    .form-row__cell {
        display: flex;
    }

    .form-row__cell__control-holder {
        width: 100%;
    }

    @media (min-width: ${BreakpointsEnum.sm}) {
        overflow: auto;
    }

    @media (max-width: ${BreakpointsEnum.sm}) {
        padding: 16px;
    }
`;

export const ModalFooter = styled.div`
    width: 100%;
    display: flex;
    padding: 16px;
    border-top: 2px solid ${({ theme }) => theme.colors.whiteSmoke[100]};
    flex-direction: column;
`;

export const StyledModal = styled(Modal)`
    padding: 24px;
    .modalClose {
        display: none;
    }

    .modalContent {
        padding: 0;
        max-width: 580px;
        width: 100%;
        display: flex;
        flex-direction: column;
        max-height: 100%;
    }

    .form-row {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        flex-basis: 100%;

        .form-control__errors-holder {
            text-align: left;
            font-size: 12px;
        }
        input:not([type='radio']),
        textarea {
            height: 48px;
            border-radius: 8px;
            padding: 0 8px;
            border: 2px solid ${({ theme }) => theme.colors.whiteSmoke[100]};
            box-shadow: none;
        }
        textarea {
            height: 80px;
        }

        &__cell__label-holder__label {
            position: relative;
            font-size: 14px;
            line-height: 22px;
            display: flex;
            align-items: center;
            color: ${({ theme }) => theme.text.color.primary};
        }

        &:not(:first-of-type) .form-row__cell__control-holder {
            margin-top: 0;
        }

        [class^='form-control'][class*='__textarea'][class*='--invalid'],
        [class^='form-control'][class*='__input'][class*='--invalid'],
        [class^='form-control'][class*='__select'][class*='--invalid'] {
            border-width: 2px;
        }
    }

    .Select-control {
        border: 2px solid ${({ theme }) => theme.colors.whiteSmoke[100]};
        border-right: none;
        height: 48px;
        border-radius: 8px 0 0 8px;

        img {
            height: 20px !important;
            width: 20px !important;
        }
    }

    @media (min-width: ${BreakpointsEnum.sm}) {
        display: flex;

        .modalContent {
            top: 0;
            margin: auto;
        }
    }

    @media (max-width: ${BreakpointsEnum.sm}) {
        padding: 0;

        .modalContent {
            position: absolute;
            bottom: 0;
            max-height: calc(100% - 56px);
            display: flex;
            flex-direction: column;
            max-width: 100%;
        }
    }
`;

export const PhoneRow = styled.div<{ hasError: boolean }>`
    display: flex;
    margin-bottom: ${({ hasError }) => (hasError ? '48px' : 0)};
    position: relative;

    .form-row {
        input:not([type='radio']) {
            border-radius: 0 8px 8px 0;
        }

        .form-control__errors-holder {
            position: absolute;
            left: 0;
        }
    }
`;

export const InputLabel = styled.label`
    font-size: 14px;
    color: ${({ theme }) => theme.text.color.primary};
    width: 100%;
    text-align: left;
    margin-top: 24px;
`;

export const NameRow = styled.div`
    display: flex;
    gap: 8px;
    .form-row {
        flex-basis: 50%;
    }
`;

export const InputWrapper = styled.div<{ optional?: boolean }>`
    display: flex;
    margin-top: 24px;

    .form-row {
        gap: 8px;
    }
`;

export const ModalButton = styled(Button)`
    @media (max-width: ${BreakpointsEnum.sm}) {
        margin-left: 0;
        width: 100%;
    }
    margin-left: auto;
`;

export const PersonalDataLegalText = styled.div`
    margin-top: 24px;
`;

export const NewsletterSubscription = styled.span`
    font-size: 12px;
`;

export const StyledLabel = styled.label<{ reverse?: boolean }>`
    display: flex;
    align-items: center;
    margin: 0;
    gap: 8px;
    font-size: 14px;
    color: ${({ theme }) => theme.text.color.primary};
    font-weight: 400;
    flex-direction: ${({ reverse }) => (reverse ? 'row-reverse' : 'row')};
`;

export const GenderRadioButton = styled.input`
    &[type='radio'] {
        border: none;
        padding: 0;
        margin: 0;
        height: 48px;
        margin-top: 0;
        width: 20px;
    }
`;

export const LegalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    margin-bottom: 16px;
    font-size: 12px;
    text-align: left;

    a {
        margin-top: 24px;
        color: ${({ theme }) => theme.link.primary};
        text-decoration: none;

        &:hover {
            color: ${({ theme }) => theme.link.primaryHover};
        }
    }
`;

export const GenderWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;
`;

export const GenderRow = styled.div`
    margin-bottom: 24px;
`;

export const StyledCheckbox = styled(InputComponent)`
    align-self: flex-start;
    width: 20px;
    height: 20px;
    margin-top: 0;
    padding: 0;
    flex-shrink: 0;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: row-reverse;
    width: 100%;
    justify-content: space-between;
    align-items: center;

    @media (max-width: ${BreakpointsEnum.sm}) {
        flex-direction: column;
        justify-content: center;
    }
`;

export const ErrorWrapper = styled.div`
    color: ${({ theme }) => theme.colors.watermelon[100]};
    font-size: 14px;
    line-height: 22px;
    font-weight: 600;
    gap: 6px;
    align-items: center;
    display: flex;
`;

export const StyledWarningIcon = styled(WarningIcon)`
    fill: ${({ theme }) => theme.colors.watermelon[100]};
    height: 16px;
    width: 16px;
    flex-shrink: 0;
`;

export const ErrorText = styled.p`
    text-align: left;
`;
